import { render } from "./ModalDocumentRename.vue?vue&type=template&id=1fc5b8b7&scoped=true"
import script from "./ModalDocumentRename.vue?vue&type=script&lang=js"
export * from "./ModalDocumentRename.vue?vue&type=script&lang=js"

import "./ModalDocumentRename.vue?vue&type=style&index=0&id=1fc5b8b7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc5b8b7"]])

export default __exports__